export default __webpack_public_path__ + "915cc95c5ec67bad8a7dcd284e83f868.jpg";